module.exports = __webpack_public_path__ + "img/edit.d7ce3858.svg";